import ViewerAuthorized from './ViewerAuthorized'
export default ViewerAuthorized
